(function () {
  'use strict';

  angular.module('flowingly.runner.sso', []);
})();
